import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions'
import { auth } from '../../../services';

export const GET_INVOICES = 'GET_INVOICES';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchInvoices() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/StripePayment/GetAllInvoices`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_INVOICES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}